import * as S from "./ResultCardItem.style";
import { ReactComponent as IconChecked } from "@/styles/assets/svg/icon_radio_checked.svg";

interface ResultCardItemProps {
  data?: any;
  name?: string;
  handleRadioClick?: (isChecked: boolean) => void;
}

export const ResultCardItem = ({
  data,
  name,
  handleRadioClick,
}: ResultCardItemProps) => {
  const handleClick = () => {
    if (handleRadioClick) {
      handleRadioClick(true);
    }
  };

  return (
    <>
      {data ? (
        <S.ResultCardItem>
          <S.ItemLabel>
            <input
              type="radio"
              name={name}
              value={data.id}
              onChange={handleClick}
            />
            <S.ItemRadioBox>
              <IconChecked width={20} height={20} />
            </S.ItemRadioBox>

            <S.ItemTextBox>
              <S.ItemUID>UID {data.id}</S.ItemUID>
              {data.name}({data.birth})
            </S.ItemTextBox>
          </S.ItemLabel>
        </S.ResultCardItem>
      ) : (
        <S.ItemLabel>
          <input type="radio" name={name} />
        </S.ItemLabel>
      )}
    </>
  );
};
